export enum CAFETERIA_MENU {
  REQUEST = 'CAFETERIA_MENU_REQUEST',
  SUCCESS = 'CAFETERIA_MENU_SUCCESS',
  FAILURE = 'CAFETERIA_MENU_FAILURE'
}

export enum CAFETERIA_CREATE_MENU {
  REQUEST = 'CAFETERIA_CREATE_MENU_REQUEST',
  SUCCESS = 'CAFETERIA_CREATE_MENU_SUCCESS',
  FAILURE = 'CAFETERIA_CREATE_MENU_FAILURE'
}

export enum CAFETERIA_EDIT_MENU {
  REQUEST = 'CAFETERIA_EDIT_MENU_REQUEST',
  SUCCESS = 'CAFETERIA_EDIT_MENU_SUCCESS',
  FAILURE = 'CAFETERIA_EDIT_MENU_FAILURE'
}

export enum CAFETERIA_UPLOAD {
  REQUEST = 'CAFETERIA_UPLOAD_REQUEST',
  SUCCESS = 'CAFETERIA_UPLOAD_SUCCESS',
  FAILURE = 'CAFETERIA_UPLOAD_FAILURE'
}

export enum CAFETERIA_CHART {
  REQUEST = 'CAFETERIA_CHART_REQUEST',
  SUCCESS = 'CAFETERIA_CHART_SUCCESS',
  FAILURE = 'CAFETERIA_CHART_FAILURE'
}

export enum CAFETERIA_STATUS {
  REQUEST = 'CAFETERIA_STATUS_REQUEST',
  SUCCESS = 'CAFETERIA_STATUS_SUCCESS',
  FAILURE = 'CAFETERIA_STATUS_FAILURE'
}

export enum MENU_CUSTOMIZATION_CREATE {
  REQUEST = 'MENU_CUSTOMIZATION_CREATE_REQUEST',
  SUCCESS = 'MENU_CUSTOMIZATION_CREATE_SUCCESS',
  FAILURE = 'MENU_CUSTOMIZATION_CREATE_FAILURE'
}

export enum MENU_CUSTOMIZATION {
  REQUEST = 'MENU_CUSTOMIZATION_REQUEST',
  SUCCESS = 'MENU_CUSTOMIZATION_SUCCESS',
  FAILURE = 'MENU_CUSTOMIZATION_FAILURE'
}

export enum MENU_CUSTOMIZATION_DETAIL {
  REQUEST = 'MENU_CUSTOMIZATION_DETAIL_REQUEST',
  SUCCESS = 'MENU_CUSTOMIZATION_DETAIL_SUCCESS',
  FAILURE = 'MENU_CUSTOMIZATION_DETAIL_FAILURE'
}

export enum MENU_CUSTOMIZATION_UPDATE {
  REQUEST = 'MENU_CUSTOMIZATION_UPDATE_REQUEST',
  SUCCESS = 'MENU_CUSTOMIZATION_UPDATE_SUCCESS',
  FAILURE = 'MENU_CUSTOMIZATION_UPDATE_FAILURE'
}

export enum MENU_MANAGEMENT_DETAIL {
  REQUEST = 'MENU_MANAGEMENT_DETAIL_REQUEST',
  SUCCESS = 'MENU_MANAGEMENT_DETAIL_SUCCESS',
  FAILURE = 'MENU_MANAGEMENT_DETAIL_FAILURE'
}

export enum MENU_MANAGEMENT_UPDATE {
  REQUEST = 'MENU_MANAGEMENT_UPDATE_REQUEST',
  SUCCESS = 'MENU_MANAGEMENT_UPDATE_SUCCESS',
  FAILURE = 'MENU_MANAGEMENT_UPDATE_FAILURE'
}

export enum REJECT_REASONS_LIST {
  REQUEST = 'REJECT_REASONS_LIST_REQUEST',
  SUCCESS = 'REJECT_REASONS_LIST_SUCCESS',
  FAILURE = 'REJECT_REASONS_LIST_FAILURE'
}

export enum REJECT_REASON_CREATE {
  REQUEST = 'REJECT_REASON_CREATE_REQUEST',
  SUCCESS = 'REJECT_REASON_CREATE_SUCCESS',
  FAILURE = 'REJECT_REASON_CREATE_FAILURE'
}

export enum REJECT_REASON_GET_ONE {
  REQUEST = 'REJECT_REASON_GET_ONE_REQUEST',
  SUCCESS = 'REJECT_REASON_GET_ONE_SUCCESS',
  FAILURE = 'REJECT_REASON_GET_ONE_FAILURE'
}

export enum REJECT_REASON_UPDATE {
  REQUEST = 'REJECT_REASON_UPDATE_REQUEST',
  SUCCESS = 'REJECT_REASON_UPDATE_SUCCESS',
  FAILURE = 'REJECT_REASON_UPDATE_FAILURE'
}

export enum ORDERS_LIST {
  REQUEST = 'ORDERS_LIST_REQUEST',
  SUCCESS = 'ORDERS_LIST_SUCCESS',
  FAILURE = 'ORDERS_LIST_FAILURE'
}

export enum ORDERS_DETAIL {
  REQUEST = 'ORDERS_DETAIL_REQUEST',
  SUCCESS = 'ORDERS_DETAIL_SUCCESS',
  FAILURE = 'ORDERS_DETAIL_FAILURE'
}
